module.exports = __webpack_public_path__ + "static/frequent-diner-00911ab6141325844651c4f702b6d1a1.svg";